/* tslint:disable */
/* eslint-disable */
export enum CreateCreditRequestConflictType {
  PendingCreditRequest = 'pending_credit_request',
  UserNotFound = 'user_not_found',
  MissingRequiredComment = 'missing_required_comment'
}
